var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ball-img",on:{"click":function($event){return _vm.startMake(true)}}},[_c('img',{attrs:{"src":"/static/images/mobile/ball.png"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }